import axiosInstance, { getApiUrl, ApiKeys, logError } from '@cp/src/utils/ApiHelper';
import { Dispatch } from 'react';
import { setUploadHistory } from './EnachSlice';

export const fetchUploadHistory = (
  pageNo: number,
  pageSize: number,
  documentTypes: string,
  status: string
) => {
  const url = getApiUrl(ApiKeys.USER_ENACH_UPLOAD_HISTORY);
  return (dispatch: Dispatch<any>) => {
    axiosInstance
      .get(url, {
        params: {
          pageNo,
          pageSize,
          documentTypes: documentTypes,
          status: status
        }
      })
      .then(response => {
        if (response) {
          dispatch(setUploadHistory(response?.data));
        }
      })
      .catch(error => {
        logError(error, 'Error inside fetchUploadHistory');
      });
  };
};
